import React, { createContext, ReactNode, useContext, useMemo } from "react";

// constants
import { CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS } from "../constants/CheckoutWebDynamicConfig";

// context
import { CheckoutWebDynamicConfigContext } from "./CheckoutDynamicConfigContext";
import { ConfigContext } from "./ConfigContext";

// helpers
import { safeJsonParse } from "@swiggy-private/js-utils";

// The actual type provided by the context - should match what's being provided
type PublicApiContextType = Record<string, Record<string, string>>;

const PublicApiContext = createContext<PublicApiContextType>({});

interface PublicApiProviderProps {
    children: ReactNode;
}

// this context is not being consumed properly and hence will be cleanedup.
export function PublicApiProvider({ children }: PublicApiProviderProps): JSX.Element {
    const { checkoutWebWP } = useContext(CheckoutWebDynamicConfigContext);
    const configContext = useContext(ConfigContext);

    // check for config of businessLine.

    const parsedConfig = useMemo(() => {
        if (!configContext) {
            return {};
        }
        const raw = checkoutWebWP?.[CHECKOUT_WEB_PUBLIC_ENDPOINT_KEYS.CW_PUBLIC_ENDPOINT_CONFIG];
        // Parse config ONCE at the top level
        return raw ? safeJsonParse<PublicApiContextType>(raw) || {} : {};
    }, [checkoutWebWP, configContext]);

    return <PublicApiContext.Provider value={parsedConfig}>{children}</PublicApiContext.Provider>;
}

export { PublicApiContext };
